export default __webpack_public_path__ + "static/media/photo--sm--1.8c4ab068.jpg";